import {Button} from 'antd';
import React from 'react';

interface PCFFooterPrimaryButtonProps {
  onClick: () => void;
  label: string;
  isSaving?: boolean;
  disabled?: boolean;
  showArrow?: boolean;
}

const PCFFooterPrimaryButton: React.FC<PCFFooterPrimaryButtonProps> = ({
  onClick,
  label,
  isSaving = false,
  disabled = false,
  showArrow = true
}) => {
  const handleClick = (): void => {
    if (isSaving || disabled) {
      return;
    }

    onClick();
  };

  return (
    <Button
      type="primary"
      className="btn-primary"
      onClick={handleClick}
      loading={isSaving}
      disabled={isSaving || disabled}
      aria-busy={isSaving}
    >
      <span>{label}</span>
      {showArrow && !isSaving && (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path
            d="M5 12H19M19 12L12 5M19 12L12 19"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </Button>
  );
};

export default PCFFooterPrimaryButton;
